module.exports = __webpack_public_path__ + "img/email-and-message.6d7aa802.png";